import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';

function AcademyPaymentWizard({ t, activeStep }) {
  let step1 = ' ';
  let step2 = ' ';
  let step3 = ' ';

  if (activeStep === 1) {
    step1 = 'step-item active';
    step2 = 'step-item deactivate';
    step3 = 'step-item deactivate';
  }
  if (activeStep === 2) {
    step1 = 'step-item active';
    step2 = 'step-item active';
    step3 = 'step-item deactivate';
  }
  if (activeStep === 3) {
    step1 = 'step-item active';
    step2 = 'step-item active';
    step3 = 'step-item active';
  }

  return (
    <div id="academy-payment-wizard" className="m-portlet__body">
      <div className="checkout-wizard-stepper">
        <div className="academy-title1-checkout">{t('checkout.tab')}</div>
        <div className="row">
          <div className={`col-lg-4 col-md-4 ${activeStep === 1 ? '' : 'tabHidden'}`}>
            <div className={step1}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-shopping-bag" />
                </div>
              </div>
              {/* <div className="icon"><i className="fas fa-list-ul" /></div> */}
              <div className="description">
                <h2>1.</h2>
                <h3>{t('shop.cart.you_order')}</h3>
              </div>
            </div>
          </div>
          <div className={`col-lg-4 col-md-4 ${activeStep === 2 ? '' : 'tabHidden'}`}>
            <div className={step2}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-map-marker-alt" />
                </div>
              </div>
              <div className="description">
                <h2>2.</h2>
                <h3>{t('billing')}</h3>
              </div>
            </div>
          </div>
          <div className={`col-lg-4 col-md-4 ${activeStep === 3 ? '' : 'tabHidden'}`}>
            <div className={step3}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-credit-card" />
                </div>
              </div>
              <div className="description">
                <h2>3.</h2>
                <h3>{t('shop.cart.payment')}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

AcademyPaymentWizard.propTypes = {
  t: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default translate(AcademyPaymentWizard);
